export function isExistingBusiness() {
  return String(sessionStorage.getItem("dealConfirmed")) === "true";
}

export function hasNewAddition(location) {
  if (location.isNewAddition) return true;
  // Nested classCodesInfo check
  if (location.classCodesInfo) {
    return Object.values(location.classCodesInfo).some(
      (cls) => cls.isNewAddition == true
    );
  }
  return false;
}

export function hasMoreThanOneNewAdditions(location) {
  if (location.isNewAddition) return true;
  // Nested classCodesInfo check
  if (location.classCodesInfo) {
    const newlyAddedCcs = Object.values(location.classCodesInfo).filter(
      (cls) => cls.isNewAddition === true
    );
    return newlyAddedCcs.length > 1;
  }
  return false;
}

export function isdealConfirmedAndHasNewAddition(props) {
  const dealConfirmed = isExistingBusiness();
  const { childrenLoc } = props;

  // Check if any isNewAddition flag is true
  const hasNewAdditions = Object.values(childrenLoc || {}).some((loc) => {
    return hasNewAddition(loc);
  });

  if (dealConfirmed && !hasNewAdditions) {
    return true; // disable
  }

  return false; // enable in all other cases
}
